// extracted by mini-css-extract-plugin
export var container = "ViewFullMap-module__container___PF7DA";
export var link = "ViewFullMap-module__link___xAoBJ";
export var viewFullMap = "ViewFullMap-module__viewFullMap___J1iGO";
export var mapImage = "ViewFullMap-module__mapImage___rOhVM";